/* eslint-disable */
import React, {
  useEffect,
  useRef,
  useState,
  forwardRef,
  useImperativeHandle,
} from "react";
import { message } from "antd";
import { CaretDownOutlined, CaretUpOutlined } from "@ant-design/icons";
import api from "@/utils/api";
import http from "@/utils/http";
import RentIcon from "@/assets/images/icons/rent.png";
import UnitDetailDrawer from "./UnitDetailDrawer";
import "./index.scss";
import Tab from "../tabs";
import RPSModal from "./RPSModal";
const DashboardRequest = forwardRef((props, ref) => {
  const [loading, setLoading] = useState(false);
  const [drawerVisible, setDrawerVisible] = useState(false);
  const [drawerType, setDrawerType] = useState("");
  const [selectedRecord, setSelectedRecord] = useState(null);
  const isFetching = useRef(false);
  const isInitialized = useRef(false);
  const RPSModalRef = useRef(null);
  const [dashboardData, setDashboardData] = useState({
    vacantUnits: [],
    vacancyRates: [],
    change: 0,
    changeRate: 0,
    last12MonthsAvgVacantDays: 0,
    last30DaysAvgVacantDays: 0,
    last90DaysAvgVacantDays: 0,
    totalUnits: 0,
  });

  // 工具函数
  const formatDate = (dateArray) => {
    if (!dateArray || dateArray.length < 3) return "";
    const [year, month, day] = dateArray;
    return `${month}/${day}/${year}`;
  };

  const formatPercent = (value) => {
    if (value === undefined || value === null) return "0%";
    return `${(value * 100).toFixed(2)}%`;
  };

  const formatNumber = (value) => {
    if (value === undefined || value === null) return "0";
    return value.toLocaleString();
  };
const getTrend = (value) => {
  if (value > 0) {
    return {
      icon: <CaretUpOutlined />,
      className: "negative",
      value: value,
    };
  }

  if (value < 0) {
    return {
      icon: <CaretDownOutlined />,
      className: "positive",
      value: value,
    };
  }

  return null;
};
  const isToday = (dateName) => dateName === "Today";

  // 组合数据
  const getCombinedData = () => {
    const { vacantUnits, vacancyRates } = dashboardData;
    const maxLength = Math.max(vacantUnits.length, vacancyRates.length);
    const result = [];

    for (let i = 0; i < maxLength; i++) {
      const unit = vacantUnits[i] || {};
      const rate = vacancyRates[i] || {};
      result.push({
        date: unit.date || rate.date,
        dateName: unit.dateName || rate.dateName || "",
        vacancyCount: unit.vacancyCount,
        vacancyRate: rate.vacancyRate,
      });
    }
    return result;
  };

  // 获取数据
  const fetchData = async () => {
    if (isFetching.current) return;
    isFetching.current = true;
    setLoading(true);

    try {
      const res = await http.get(api.getSnapshotShow);
      if (res?.code === "1" && res?.data) {
        setDashboardData({
          vacantUnits: res.data.vacantUnits || [],
          vacancyRates: res.data.vacancyRates || [],
          change: res.data.change || 0,
          changeRate: res.data.changeRate || 0,
          last12MonthsAvgVacantDays: res.data.last12MonthsAvgVacantDays || 0,
          last30DaysAvgVacantDays: res.data.last30DaysAvgVacantDays || 0,
          last90DaysAvgVacantDays: res.data.last90DaysAvgVacantDays || 0,
          totalUnits: res.data.totalUnits || 0,
        });
      } else {
        message.error(res?.msg || "Failed to fetch data");
      }
    } catch (error) {
      console.error("Fetch error:", error);
      message.error("Failed to fetch data");
    } finally {
      setLoading(false);
      isFetching.current = false;
      isInitialized.current = true;
    }
  };

  useImperativeHandle(ref, () => ({
    refresh: () => {
      if (isInitialized.current) fetchData();
    },
  }));

  useEffect(() => {
    fetchData();
  }, []);

  // Drawer
  const handleOpenDrawer = (record, type) => {
    setSelectedRecord(record);
    setDrawerType(type);
    setDrawerVisible(true);
  };

  const handleCloseDrawer = () => {
    setDrawerVisible(false);
    setSelectedRecord(null);
    setDrawerType("");
  };

const renderDataList = () => {
  const data = getCombinedData();
  if (!data.length) {
    return <div className="vacdash-empty">No data available</div>;
  }

  const todayIndex = data.findIndex((item) => isToday(item.dateName));

  return (
    <div
      className="vacdash-data-list"
      style={{ gridTemplateColumns: `repeat(${data.length}, 1fr) 30px` }}
    >
      {data.map((item, index) => {
        const isTodayItem = isToday(item.dateName);

        let countChange = null;
        let rateChange = null;
        if (isTodayItem && todayIndex > 0) {
          const yesterday = data[todayIndex - 1];
          if (yesterday) {
            countChange = (item.vacancyCount || 0) - (yesterday.vacancyCount || 0);
            rateChange = (item.vacancyRate || 0) - (yesterday.vacancyRate || 0);
          }
        }

        const handleItemClick = () => {
          if (isTodayItem) {
            handleOpenDrawer(item, "today");
          }
        };

        return (
          <div
            key={index}
            className={`vacdash-data-item ${isTodayItem ? "vacdash-today-item" : ""}`}
            onClick={handleItemClick}
            style={{ cursor: isTodayItem ? "pointer" : "default" }}
          >
            <div className="vacdash-data-date">{formatDate(item.date)}</div>
            <div className="vacdash-data-weekday">{item.dateName}</div>
            <div className="vacdash-value-row">
              <span className="vacdash-count">
                {formatNumber(item.vacancyCount || 0)}
              </span>

              {isTodayItem && getTrend(dashboardData.change) && (
                <span className={`vacdash-change ${getTrend(dashboardData.change).className}`}>
                  {getTrend(dashboardData.change).icon}
                </span>
              )}
            </div>
            <div className="vacdash-value-row">
              <span className="vacdash-rate">
                {formatPercent(item.vacancyRate || 0)}
              </span>

              {isTodayItem && getTrend(dashboardData.changeRate) && (
                <span className={`vacdash-change ${getTrend(dashboardData.changeRate).className}`}>
                  {getTrend(dashboardData.changeRate).icon}
                  {formatPercent(Math.abs(dashboardData.changeRate))}
                </span>
              )}
            </div>
          </div>
        );
      })}
      <div className="vacdash-more-item" onClick={handleViewAll}>
        <span className="vacdash-more-icon">》</span>
      </div>
    </div>
  );
};
  // 指标数据
  const metrics = [
    {
      key: "30days",
      label: "Last 30 Days Avg",
      value: dashboardData.last30DaysAvgVacantDays,
      color: "#BEDBFD",
    },
    {
      key: "90days",
      label: "Last 90 Days Avg",
      value: dashboardData.last90DaysAvgVacantDays,
      color: "#4D8CF2",
    },
    {
      key: "12months",
      label: "Last 12 Months Avg",
      value: dashboardData.last12MonthsAvgVacantDays,
      color: "#265FFF",
    },
  ];

    const handleViewAll = () => {
    if (RPSModalRef.current) {
      RPSModalRef.current.open();
    }
  };

return (
  <div className="vacdash-page">
    <div className="vacdash-container">
      {/* 左侧 */}
      <div className="vacdash-left">
        {renderDataList()}
      </div>

      {/* 右侧 */}
      <div className="vacdash-right">
        <div className="vacdash-units-card">
          <div className="vacdash-units-icon">
            <img src={RentIcon} alt="Total Units" />
          </div>
          <div className="vacdash-units-content">
            <div className="vacdash-units-label">Total Units</div>
            <div className="vacdash-units-value">
              {formatNumber(dashboardData.totalUnits)}
            </div>
          </div>
        </div>

        <div className="vacdash-metrics">
          {metrics.map((metric) => (
            <div key={metric.key} className="vacdash-metric-item">
              <div className="vacdash-metric-info">
                <div
                  className="vacdash-metric-line"
                  style={{ background: metric.color }}
                />
                <div className="vacdash-metric-label">{metric.label}</div>
                <div className="vacdash-metric-value">{metric.value}</div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </div>

    <div className="vacdash-tabs">
      <Tab />
    </div>
    <UnitDetailDrawer
      visible={drawerVisible}
      onClose={handleCloseDrawer}
      drawerType={drawerType}
      record={selectedRecord}
    />
    <RPSModal ref={RPSModalRef} />
  </div>
);
});

export default DashboardRequest;
